import React from 'react'
import { useNavigate } from 'react-router-dom'

import FocusableCard from './FocusableCard'
import PassportBadge from '../PassportBadge'
import ProgressBar from '../ProgressBar'

import type { CardProps } from './types'
import type { Video } from '../../reducers/types/reducerTypes'

export function VideoCard({
  data,
  index,
  onFocus,
  layout,
  ttsCounterText,
  onLeftExit,
}: CardProps<Video>) {
  const navigate = useNavigate()

  const bgImage =
    data.images['asset-mezzanine-16x9'] ||
    data.images['asset-kids-mezzanine1-16x9'] ||
    ''
  const episodeTitle = data.title
  let showTitle
  if (data.parent.season) {
    showTitle = data.parent.season.show.title
  } else {
    showTitle = data.parent.show?.title
  }

  const handleOnEnterPress = () => {
    navigate(
      `/video-details/${encodeURIComponent(data.url)}?availability=${
        data.availability
      }`
    )
  }

  const hasImage = !!bgImage
  return (
    <FocusableCard<Video>
      index={index}
      onFocus={onFocus}
      layout={layout}
      ttsText={`${ttsCounterText} .... ${showTitle} .... ${episodeTitle}`}
      onEnterPress={handleOnEnterPress}
      onLeftExit={onLeftExit}
    >
      <div className="video-card">
        {data.flags.is_mvod && (
          <PassportBadge sizePx={120} className="video-card__passport-badge" />
        )}
        {hasImage && (
          <img
            className="video-card__background-image"
            src={`${bgImage}?resize=487x274&format=webp`}
            alt={`${showTitle} show poster`}
          />
        )}
        {!hasImage && <span className="video-card__title">{showTitle}</span>}
        {data.seconds_watched ? (
          <ProgressBar current={data.seconds_watched} total={data.duration} />
        ) : null}
      </div>
      <h3 className="video-card__show-title">{showTitle}</h3>
      <h3 className="video-card__episode-title">{episodeTitle}</h3>
    </FocusableCard>
  )
}
